export default "https://cdn-static.gokick.com/assets/ec4df3605d889435bba193590f9e5f4fca0b05f8/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";